import { AppThunk } from 'types';
import { osName, osVersion } from 'react-device-detect';
import axios, { AxiosError } from 'axios';
import _get from 'lodash/get';
import * as actions from 'store/actions';
import qs from 'qs';
import appJson from '../../../../package.json';

interface ApiCredentials {
  os?: string;
  osver?: string;
  appver?: string;
  AppKey?: string;
}

export const apiPost = <D, T extends Record<string, unknown> = Record<string, string>>(
  apiCall: string,
  data: T,
  noToken = false,
): AppThunk<Promise<D | null>> => {
  return async (dispatch, getState) => {
    const { auth } = getState();
    const { app } = getState();

    const storedSessionToken = localStorage.getItem('sessionToken');

    let sessionToken;
    if (!noToken) {
      if (auth.sessionToken) sessionToken = auth.sessionToken;
      else if (storedSessionToken) sessionToken = storedSessionToken;
    }
    if (!sessionToken && !noToken) return null;

    const url = `${app.selectedServer?.URL || app.defaultServer}${apiCall}/${sessionToken || 'NO_SESSION'}`;
    const newData: T & ApiCredentials = data;
    newData.os = osName;
    newData.osver = osVersion;
    newData.appver = appJson.version;
    newData.AppKey = 'desktop';
    try {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-call,@typescript-eslint/no-unsafe-member-access
      const response = await axios.post<D>(url, qs.stringify(newData));
      if (app.debugMode) {
        // eslint-disable-next-line no-console
        if (_get(response, 'data.error_message')) console.log(`There is an error_message!: ${_get(response, 'data.error_message') as string}`);
        // eslint-disable-next-line no-console
        console.log('apiCall: ', apiCall);
        // eslint-disable-next-line no-console
        console.log('apiGet - response:', response);
      }
      return response.data;
    } catch (error) {
      const response = _get(error, 'response') as AxiosError<D>['response'];

      // eslint-disable-next-line no-console
      console.error('Error in apiCall: ', apiCall);
      // eslint-disable-next-line no-console
      if (_get(response, 'data')) console.log('apiPost - error.response.data: ', _get(response, 'data'));
      if (_get(response, 'data.auto_logout') && sessionToken) {
        if (sessionToken) dispatch(actions.logout(true));
      } else if (_get(response, 'data.error_code') === 20) {
        dispatch(actions.accountNeedsVerification('Email'));
      } else if (_get(response, 'data.error_code') === 21) {
        dispatch(actions.accountNeedsVerification('Phone'));
        // errors with code 10 errors are thrown when user needs to verify their account.
        // In these cases, rather than logging an app error, we'll send them to /verify
      } else if (_get(response, 'data.error_message') && _get(response, 'data.error_code') !== 10) {
        dispatch(actions.logAppError(_get(response, 'data.app_error_title'), _get(response, 'data.error_message')));
      }
      throw error;
    }
  };
};

export default {};
